import Vue from 'vue';
import Component from 'vue-class-component';
import {XTreeItem} from '../../models/NavTreeModel';
import {getTreeChildren} from '../../models/NavTreeModel';


@Component({
    name:'xtree-menu',
 
    props:{
        label:{
            type:String,
        },
        children:{
        },
       depth:{
        },
        viewportid:{
        },
        rootlink:{
        },
        currentlink:{
        },
        parentlink:{
        },
        contextpath:{
        },
        activepagetitle:{
        },
        activepageid:{
        },
        activepagelink:{
        },
        ancestors:{
        },
        type:{ 
        }
    },
    components:{
        'xtree-menu':XtreeMenu
    }
})

export default class XtreeMenu extends Vue{

    label:string;
    depth:number;
    isOpen:boolean=false;
    childLoaded:boolean=false;
    isSelected:boolean=false;

    children;
    viewportid:string;
    rootlink:string;
    currentlink:string;
    parentlink:string;
    contextpath:string;
    activepagelink:string;
    ancestors:string;
    type:string;


    itemChildren = [];


    get indent(){
        return {transform: `translate(${this.depth *20}px`}
    }

    
    get getAncestors():string[]{
   // console.log("ANCESTORS--- ",this.ancestors);

    return this.ancestors.split('|');
  }

  setLinkState(){
 //console.log("LINK-STATE  type= ",this.type);

      if(this.type.toLowerCase() === "ancestor" || this.type.toLowerCase() === "current"){
          this.isOpen=true;
        }

    if(this.type.toLowerCase() === "current")
    {
        this.isSelected=true;
    }
  }
     

    toggleChildren(){
       // console.log("TOGGLE-GEKLICKT");
        if(!this.isOpen){
            this.loadChildren();
        }
      //  console.log('WURDE GEÖFFNET.....');
        this.isOpen = !this.isOpen;
        //console.log("OPEN-STATU IS: ",this.isOpen);
    }

 get iconClasses(){
    return {
    'fa-circle':!this.hasChildren(),
    'fa-chevron-right ':!this.isOpen,
    'fa-chevron-down ':this.isOpen
  }
}

get liClasses(){
    return {
        'active':this.isOpen,
        'selected':this.isSelected
    }
}

get selectedLinkClass(){
    return {
        'active':this.isOpen,
        'selected':this.isSelected
    }
}

getChildren(){
    return this.itemChildren;
}

public filterChildTitle():string{
    return this.label.replace(/ *\([^)]*\) *$/, "");
}

public hasChildren():boolean{
return this.children!==undefined && this.children;
}

    loadChildren(){
        if(this.hasChildren()){
        /*
        console.log('viewport:',this.viewportid);
        console.log('rootlink:',this.rootlink);
        console.log('currentLink:',this.activepagelink);
        console.log('parentLink:',this.currentlink);
        console.log('contextPath:',this.contextpath);
        console.log('activ-Link:',this.activepagelink)
    */    
    }
            
        getTreeChildren(
            this.contextpath, //contextPath
            this.viewportid, //viewportId
            this.rootlink, //rootlink
            this.currentlink, //parentlink
            this.activepagelink //currentlink
        )
        .then((children_local)=>{
            if(children_local && children_local.length>0){
            // this.hasChilds=true;
              //  console.log("TESTING THIS CONTEXT: ", this.itemChildren);
                this.itemChildren=children_local;
              //  console.log("AVAILABLE CHILDREN XTREE: ",this.children);
            }
        })
        .fail((jqXHR,textStatus, errorThrown)=>{
    
        })
    }


    created(){
      //  console.log('SINGLE-XTREEMENU CREATED',this.currentlink);
       // console.dir(this.children);
        if(this.hasChildren){
            this.itemChildren = this.children;
        }
      //  this.loadChildren();
        this.setLinkState();
    }
    
}